import React from 'react';
import Icon from '../Icon/index.js';
import { StyledDescription, IconWrapper, StyledDescriptionParagraph } from './style.js';
var descriptionIcons = {
  info: React.createElement(Icon.State, {
    styleType: "info",
    size: "x-small",
    color: "#868E96"
  }),
  error: React.createElement(Icon.State, {
    styleType: "danger",
    size: "x-small"
  })
};

function Description(_a) {
  var state = _a.state,
      messages = _a.messages,
      messageKey = _a.messageKey; // 특정 메세지 키의 메세지가 빈 문자열 또는 undefined인 경우
  // 그 상태에선 컴포넌트가 렌더링되지 않음

  if (!messages[messageKey]) {
    return null;
  }

  return React.createElement(StyledDescription, null, React.createElement(IconWrapper, null, descriptionIcons[state]), React.createElement(StyledDescriptionParagraph, {
    state: state
  }, messages[messageKey]));
}

export { Description as default };